import Css from "./LoadingField.module.css";

export default function LoadingField() {
    return(
        <div className={Css.mainDiv + " animated-background"}></div>
    )
}